"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PanelHeader = exports.PanelFooter = exports.PanelBody = exports.Panel = void 0;
var React = _interopRequireWildcard(require("react"));
var _useMountTransition = _interopRequireDefault(require("../../hooks/useMountTransition"));
var _motion = require("../../styles/variables/_motion");
var _space = require("../../styles/variables/_space");
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _Button = require("../Button");
var _Modal = require("../Modal");
var _Truncate = require("../Truncate");
var _PanelModule = _interopRequireDefault(require("./Panel.module.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const getDefaultPanelAnimation = anchor => ({
  // Configure both open and close durations:
  duration: {
    open: parseInt(_motion.motionDurationSlow),
    close: parseInt(_motion.motionDurationNormal)
  },
  initial: {
    transform: `translateX(${anchor === 'right' ? _space.spaceFluid : _space.spaceNegFluid})`
  },
  open: {
    transform: `translateX(${_space.spaceNone})`
  },
  close: {
    transform: `translateX(${anchor === 'right' ? _space.spaceFluid : _space.spaceNegFluid})`
  }
});
const PanelHeader = _ref => {
  let {
    children,
    hideCloseBtn,
    onCloseButtonClick,
    className,
    size
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, React.Children.count(children) > 0 && /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_PanelModule.default.panelHeader, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: _PanelModule.default.headerContent
  }, /*#__PURE__*/React.createElement(_Truncate.Truncate, null, children)), !hideCloseBtn && /*#__PURE__*/React.createElement(_Button.Button, {
    iconLeftName: "xmark",
    type: "ghost",
    onClick: onCloseButtonClick,
    ariaLabel: "Close Button",
    size: size
  })));
};
exports.PanelHeader = PanelHeader;
const PanelBody = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    children,
    className
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: (0, _classify.default)(_PanelModule.default.panelBody, className)
  }, children);
});
exports.PanelBody = PanelBody;
const PanelFooter = _ref3 => {
  let {
    children,
    classNames
  } = _ref3;
  return /*#__PURE__*/React.createElement(React.Fragment, null, React.Children.count(children) > 0 && /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_PanelModule.default.panelFooter, classNames?.wrapper)
  }, /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_PanelModule.default.panelFooterActions, classNames?.actions)
  }, children)));
};
exports.PanelFooter = PanelFooter;
const Panel = _ref4 => {
  let {
    children,
    isOpen = false,
    size = 'medium',
    anchor = 'left',
    onClose,
    hideBackdrop = true,
    classNames,
    customAnimation,
    tapOutsideToClose = true,
    allowBackgroundInteraction,
    ...restPanelProps
  } = _ref4;
  const isTransitioning = (0, _useMountTransition.default)(isOpen, parseInt(_motion.motionDurationNormal));
  const defaultPanelAnimation = getDefaultPanelAnimation(anchor);
  return /*#__PURE__*/React.createElement(_Modal.Modal, _extends({
    isOpen: isOpen,
    onClose: onClose,
    hideBackdrop: hideBackdrop,
    tapOutsideToClose: allowBackgroundInteraction ? false : tapOutsideToClose,
    allowBackgroundInteraction: allowBackgroundInteraction
  }, restPanelProps, {
    classNames: {
      container: (0, _classify.default)(_PanelModule.default.panelContainer, {
        [_PanelModule.default.in]: isTransitioning,
        [_PanelModule.default.open]: isOpen
      }, classNames?.container),
      content: (0, _classify.default)(_PanelModule.default.panel, _PanelModule.default[anchor], {
        [_PanelModule.default.medium]: size === 'medium',
        [_PanelModule.default.small]: size === 'small',
        [_PanelModule.default.large]: size === 'large'
      }, classNames?.content),
      backdrop: (0, _classify.default)(classNames?.backdrop)
    },
    customAnimation: customAnimation || defaultPanelAnimation
  }), children);
};
exports.Panel = Panel;